import { useEffect, useState } from "react";
import { fetchWeatherData, type WeatherData } from "@/services/weatherService";
import { getWeatherIcon } from "@/utils/weatherIcons";

interface WeatherWidgetProps {
  location: string;
  lat: number;
  lon: number;
  apiKey?: string;
}

export const WeatherWidget = ({ location, lat, lon, apiKey }: WeatherWidgetProps) => {
  const [weather, setWeather] = useState<WeatherData>({
    location: location,
    description: "Cargando...",
    temp: 0,
    weatherCode: 800
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWeather = async () => {
      try {
        const data = await fetchWeatherData(location, lat, lon, apiKey);
        setWeather(data);
      } catch (error) {
        // Fallback to mock data if API fails
        setWeather({
          location: location,
          description: "Parcialmente nublado",
          temp: 18,
          weatherCode: 801
        });
      } finally {
        setLoading(false);
      }
    };

    loadWeather();
  }, [lat, lon, location, apiKey]);

  const WeatherIcon = getWeatherIcon(weather.weatherCode);

  return (
    <div className="weather-widget">
      <div className="weather-left">
        <div className="weather-location">{weather.location}</div>
        <div className="weather-desc">
          {loading ? "Cargando..." : weather.description}
        </div>
      </div>
      <div className="weather-right">
        <WeatherIcon className="weather-icon text-white" />
        <div className="weather-temp">{weather.temp}°</div>
      </div>
    </div>
  );
};
